.card {
  box-sizing: border-box;
  // Allow utility classes to override, keep this in stylesheet
  padding: 24px;
  border-radius: 20px;
  background: var(--container);
  transition: box-shadow var(--fast-s);

  // Top and bottom offsets allow for margin collapse
  .top-offset {
    height: 1px;
    margin-top: -1px;
    margin-bottom: 24px;
  }
  .bottom-offset {
    height: 1px;
    margin-top: 24px;
    margin-bottom: -1px;
  }

  &.raised {
    box-shadow: 2px 4px 8px 0 var(--outline);
  }

  &.dugout {
    background: var(--dugout);
  }
  &.marginCollapsible {
    padding: 0 24px;
  }
}

.card-item.card-item {
  // TODO: Get proper element height
  height: 1.5em;
  margin: 24px 0;
}
